module.exports = __webpack_public_path__ + "static/img/product3.904ae91.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product3.png
// module id = x+ht
// module chunks = 1